import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { LeverageTokenCheckoutSummaryComponent } from "./leverage-token-checkout-summary.component";

@NgModule({
	declarations: [LeverageTokenCheckoutSummaryComponent],
	imports: [CoreModule],
	exports: [LeverageTokenCheckoutSummaryComponent]
})
export class LeverageTokenCheckoutSummaryModule {}
